export default __webpack_public_path__ + "static/bg-grain-dark-a19bff220df3a25116cc82dec33a3e77.png";